import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Plan } from './planModel';
import { environment } from 'src/environments/environment';
import { lastValueFrom, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PlanService {
  selectedPlan: any = null;
  base = `${environment.BASE_LA}/api`;
  constructor(public httpClient: HttpClient) {}

  createPlan(plan: Plan) {
    return this.httpClient.post(`${this.base}/plans`, plan);
  }

  updatePlan = async (body:any) => {
    const headers = { 'content-type': 'application/json' };

    try {
      const response = await lastValueFrom(
        this.httpClient.put<any>(
          `${this.base}/plans`,
          body,
          { headers }
        )
      );
      return response;
    } catch (error) {
      console.error('Error updating default plan:', error);

      // Re-throw the error or return a rejected promise so it propagates correctly
      return Promise.reject(error);
    }
  };

  // Actualizar solo las listas de fees de un plan
  updatePlanFees = async (planCode: string, white_list_fees: string[], black_list_fees: string[]) => {
    const headers = { 'content-type': 'application/json' };
    const body = {
      code: planCode,
      white_list_fees: white_list_fees,
      black_list_fees: black_list_fees
    };

    try {
      console.log('🌐 Llamando al endpoint PUT /api/plans/fees');
      console.log('📤 Body:', body);
      
      const response = await lastValueFrom(
        this.httpClient.put<any>(
          `${this.base}/plans/fees`,
          body,
          { headers }
        )
      );
      
      console.log('📥 Respuesta del servidor:', response);
      return response;
    } catch (error) {
      console.error('❌ Error updating plan fees:', error);
      return Promise.reject(error);
    }
  };

  deletePlan = async (planId: string) => {
    const headers = { 'content-type': 'application/json' };
    const body = { id_plan: planId };

    debugger

    try {
      const response = await lastValueFrom(
        this.httpClient.post<any>(
          `${this.base}/plans/delete-plan`,
          body,
          { headers }
        )
      );
      return response;
    } catch (error) {
      console.error('Error deleting plan:', error);

      // Re-throw the error or return a rejected promise so it propagates correctly
      return Promise.reject(error);
    }
  };

  getAllPlans(plan: Plan) {
    return this.httpClient.get(`${this.base}/plans/all`);
  }

  getPlanByCode(code: string) {
    const params = new HttpParams().set('code_plan', code);

    return this.httpClient.get<any>(`${this.base}/plans/`, { params });
  }

  getCodes() {
    return this.httpClient.get(`${this.base}/code`);
  }

  getMultiProductCode() {
    return this.httpClient.get(`${this.base}/invoice-credit/invoice_product_code`);
  }

  /**
   * Verificar si un código de plan ya existe
   */
  checkCodeExists(code: string) {
    console.log('🌐 PlanService.checkCodeExists llamado con código:', code);
    const params = new HttpParams().set('code', code);
    const url = `${this.base}/plans/check-code`;
    console.log('📍 URL completa:', url, 'Params:', params.toString());
    return this.httpClient.get<any>(url, { params });
  }
}
